import { InvolvedPartyRelationType } from "app/intake/party/involvedPartyRelationType";
import { Country } from "./country.model";
import { HealthInsurance } from "./health-insurance.model";
import { Relationship } from "./relationship.model";
import { TravelInsurance } from "./travel-insurance.model";

export class FellowTraveller {
   dossierId: string = null;
  fellowTravellerId:string = null;
  ftdId: string = null;
  ftdParentId: string = null;
  ftdConcernedPersonType = null;
  ftdRelationship: Relationship = new Relationship();
  ftdEscortType: string = null;
  concernedPersonTypeLabel: string = null;
  ftdInitials: string = null;
  ftdFirstName: string = null;
  ftdLastName: string = null;
  ftdIMaidenName: string = null;
  ftdGender: any = null;
  ftdActive: any = null;
  ftdDateOfBirth: Date;
  ftdHasSameInsureeAddress: boolean = null;
  ftdHasSameInsurerContact: boolean = null;
  ftdPostalCode: string = null;
  ftdHouseNumber: string = null;
  ftdHouseNumberAddition: string = null;
  ftdStreetName: string = null;
  ftdCity: string = null;
  country: Country = null;
  ftdEffectiveDate: Date = null;
  ftdPhoneNumber: string = null;
  ftdPhoneNumber2: string = null;
  ftdEmail: string = null;
  ftdRemarks: string = null;
  ftdHasSameTravelInsurance: boolean = null;
  ftdHasTravelInsurance: string = null;
  ftdTravelInsuranceNumber: string = null;
  piaCheckResult = [];
  ftdTravelInsurances: TravelInsurance[] = []
  selectedHealthPolicies: HealthInsurance[] = []
  ftdMiddleName: string = null;
  ftdInvolvedPartyRelationType = new InvolvedPartyRelationType();
  ftdAssignmentId: string = null;
}